<div class="widget-body border-box border-lighter-gray product-widget background-white col-xs-12">
  <img class="feature-image-left" src="assets/i/widgets/product-selector-widget-image.png">
  <div class="content">
    <h2 class="color-gray">Use the Product selector to discover the best products to use at each stage of ADEY® Best Practice by answering a few simple questions...</h2>
    <div class="widget-button-container">
      <button class="btn background-green no-radius color-white" (click)="goToPage('/product-selector')">Best product for the job</button>
    </div>
  </div>
</div>
